// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cBpt","newExpiryDate":"styles_newExpiryDate__9b2_c","footer":"styles_footer__9Wrxx"};